// language=GraphQL
export const ALL_DESTINATIONS_QUERY = `query Query {
  destinations: travelDestinations {
    id
    name
    entryRequirements
    medicalInformation
    language
    timeShift
    climate
    currency
  }
}`

// language=GraphQL
export const SINGLE_DESTINATION_QUERY = `query Query($id: ID!) {
  destination: travelDestination(id: $id) {
    id
    name
    entryRequirements
    medicalInformation
    language
    timeShift
    climate
    currency
  }
}`

// language=GraphQL
export const CREATE_DESTINATION_MUTATION = `
  mutation Mutation($input: CreateTravelDestinationInput) {
    destination: createTravelDestination(input: $input) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
  }`

// language=GraphQL
export const UPDATE_DESTINATION_MUTATION = `
  mutation Mutation($input: UpdateTravelDestinationInput) {
    destination: updateTravelDestination(input: $input) {
      id
      name
      entryRequirements
      medicalInformation
      language
      timeShift
      climate
      currency
    }
  }`

// language=GraphQL
export const DELETE_DESTINATION_MUTATION = `
  mutation Mutation($input: DeleteTravelDestinationInput) {
    deleteTravelDestination(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_DESTINATION_MUTATION = `
  mutation Mutation($input: DeleteTravelDestinationInput) {
    forceDeleteTravelDestination(input: $input) {
      success
    }
  }`
// language=GraphQL
export const DESTINATIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false, $withCmsPrefilteredTravelsBlocks: Boolean = false, $withCmsDestinationsBlocks: Boolean = false) {
  groupedDependents: travelDestinationDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency    }
    cmsPrefilteredTravelsBlocks @include(if: $withCmsPrefilteredTravelsBlocks) {
      id
      maxResults    }
    cmsDestinationsBlocks @include(if: $withCmsDestinationsBlocks) {
      id
    }
  }
}`
